import { Flex, Link } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";
import { useSearchInfiniteContext } from "../../SearchInfinite/useSearchInfiniteContext";

function Reset() {
  const { appliedFilters, reset } = useSearchInfiniteContext();

  return (
    <Flex
      justify="flex-end"
      pt=".25rem"
      opacity={appliedFilters.length > 0 ? 1 : 0}
      visibility={appliedFilters.length > 0 ? "visible" : "hidden"}
      transition="all .25s ease">
      <Link
        onClick={reset}
        textAlign="right"
        fontSize="0.75rem"
        color="gray.600">
        <FormattedMessage defaultMessage="Réinitialiser les filtres" />
      </Link>
    </Flex>
  );
}

export default Reset;
